export default "__VITE_ASSET__D64PV2Wx__"